import { FC } from "react";
import lightLogo from "../../../images/logo-white.png";

const LandingLoadingScreen: FC = () => {
  return (
    <div className="flex items-center justify-center min-h-dvh bg-gray-7">
      <img src={lightLogo} alt="Unspokenn" className="h-10" />
    </div>
  );
};

export default LandingLoadingScreen;
